import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      gap: '2.5em',
      alignItems: 'center',
      width: '100%',
      border: theme.palette.type === 'dark' ? '1px solid #2d343e' : `1px solid ${COLORS.LIGHT_BORDER}`,
      borderRadius: 8,
      padding: 30,
      backgroundImage:
        theme.palette.type === 'dark'
          ? `linear-gradient(270deg, rgba(18,18,25,0.6) 0%, rgba(13,18,25,1) 30%), url(/casting-background.png)`
          : `linear-gradient(270deg, rgba(237, 241, 246,0.5) 0%, rgba(237, 241, 246,1) 30%), url(/casting-background.png)`,
      backgroundSize: 'auto 100%',

      [theme.breakpoints.down('xs')]: {
        backgroundImage:
          theme.palette.type === 'dark'
            ? 'linear-gradient(0deg, rgba(18,18,25,0.9) 0%, rgba(13,18,25,1) 50%), url(/casting-background.png)'
            : `linear-gradient(0deg, rgba(237, 241, 246,0.5) 0%, rgba(237, 241, 246,1) 30%), url(/casting-background.png)`,
      },
    },
    qrContainer: {
      height: 299,
      width: 299,
      background: '#0a0b15',
      borderStyle: 'solid',
      borderWidth: '3px',
      borderImageSource: `linear-gradient(253deg, ${COLORS.PRIMARY}, ${COLORS.PRIMARY})`,
      borderImageSlice: '1',
      backgroundImage:
        theme.palette.type === 'dark'
          ? 'linear-gradient(to bottom, #0c0f14, #0c0f14), linear-gradient(253deg, #d51bff, #00d4ff)'
          : 'linear-gradient(to bottom, #fff, #fff), linear-gradient(253deg, #fff, #fff)',
      backgroundOrigin: 'border-box',
      backgroundClip: 'content-box, border-box',
      borderRadius: '8px !important',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    input: {
      marginTop: '20px!important',
      '& .MuiInputBase-root': {
        height: '44px!important',
        '& fieldset': {
          borderRadius: 8,
          border: 'solid 1px #2d343e',
        },
      },

      '& .MuiInputAdornment-positionStart': {
        marginRight: 15,
      },

      '& .MuiSvgIcon-root': {
        fontSize: 20,
      },

      '& input::placeholder': {
        color: '#60718b',
        letterSpacing: 0.4,
        fontWeight: 500,
        opacity: 0.9,
      },

      '& .MuiFormHelperText-root': {
        color: COLORS.DANGER,
        margin: '10px 0 0',
        fontSize: 14,
      },
    },
    buttonCls: {
      marginTop: 10,
      height: '44px !important',
      borderRadius: 8,
      textTransform: 'unset',
      maxWidth: 320,
      fontSize: 15,
    },
    link: {
      color: COLORS.PRIMARY,
      textDecoration: 'underline',
    },
  }),
);
